import React from 'react';
import { iconsSources } from '../../helpers/icons';
import styles from './Message.module.css';
import { hideNumber } from '../../helpers/titreHelper';
import cn from 'classnames';

const Message = ({
  color,
  message,
  closeHandler,
  selectHandler,
  isSelected,
  isClosed,
  resetSelectHandler,
  setModalContent,
  authorFontSize,
  msgFontSize,
}) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.closed]: isClosed || !isSelected,
      })}
      onClick={() => resetSelectHandler(message.id)}
      onDoubleClick={() => selectHandler(message.id)}
    >
      <button
        className={styles.hideBtn}
        onClick={() => closeHandler(message.id)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      {message && (
        <>
          <div className={styles.top}>
            <div
              className={styles.avatar}
              style={{ '--clr': color || '#df5a23' }}
            >
              <img
                src={
                  (message?.image !== '1' && message?.image) ||
                  iconsSources[message?.channel]
                }
                alt={message?.author}
                onError={errorHandler}
              />
            </div>
            <div
              className={styles.name}
              style={{
                fontSize: `${authorFontSize}rem`,
                lineHeight: `${authorFontSize}rem`,
              }}
            >
              <div> {message?.author || hideNumber(message?.senderNumber)}</div>
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.textWrapper}>
              <div
                className={styles.text}
                style={{ fontSize: `${msgFontSize}rem` }}
              >
                {message?.content}
              </div>
              <div className={styles.attachments}>
                {message.attachments &&
                  message.attachments.map((file) => {
                    if (file.type === 'image') {
                      return (
                        <img
                          onClick={() => setModalContent(file.url)}
                          key={file.url}
                          src={file.url}
                          alt={file.url}
                        />
                      );
                    }
                    if (file.type === 'video') {
                      return (
                        <video key={file.url} src={file.url} controls></video>
                      );
                    }
                    if (file.type === 'audio_msg') {
                      return (
                        <audio key={file.ogg} src={file.ogg} controls></audio>
                      );
                    }
                    if (file.type === 'audio') {
                      return (
                        <audio key={file.url} src={file.url} controls></audio>
                      );
                    }
                    return false;
                  })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
